export function isHouseholdFitnessLogin(activeFitnessProfile) {
	return Boolean(activeFitnessProfile?.id);
}

export function hasActiveSubscription(subscription) {
	return (
		subscription &&
		Object.keys(subscription).length > 0 &&
		subscription.status === 'active'
	);
}

export function requiresSubscription({ subscription, activeFitnessProfile }) {
	if (isHouseholdFitnessLogin(activeFitnessProfile)) {
		return false;
	}

	return !hasActiveSubscription(subscription);
}
